import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface SearchResultMarkProps extends ComponentPropsWithoutRef<'p'> {}

const SearchResultMark = (props: SearchResultMarkProps) => {
    const { className = '', children, ...rest } = props;
    const isSnippet = typeof children === 'string';

    return (
        <p
            className={twMerge('[&_mark]:bg-yellow-100', className)}
            {...(isSnippet
                ? {
                      dangerouslySetInnerHTML: {
                          __html: children,
                      },
                  }
                : {
                      children,
                  })}
            {...rest}
        />
    );
};

export { SearchResultMark };
export type { SearchResultMarkProps };
